import React from "react";
import { useSearchParams, Link } from "react-router-dom";

export default function PresaleSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id") || "";

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#070b11",
        color: "#e0e8f4",
      }}
    >
      <div
        style={{
          maxWidth: 480,
          width: "100%",
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(0,229,176,0.25)",
          borderRadius: 16,
          padding: "32px 28px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 44, marginBottom: 12 }}>✅</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 10 }}>
          Payment Received
        </h1>
        <p style={{ color: "#9aa5b5", fontSize: 14, lineHeight: 1.6, marginBottom: 18 }}>
          Your card payment was confirmed by Stripe. To finish your Pre-Sale
          allocation, go back to the <strong style={{ color: "#e0e8f4" }}>Ego Desktop app</strong>{" "}
          and click <strong style={{ color: "#00e5b0" }}>Verify Payment</strong> to
          generate your encrypted IOU claim file.
        </p>
        {sessionId && (
          <div
            style={{
              fontFamily: "monospace",
              fontSize: 11,
              color: "#5a6472",
              background: "rgba(0,0,0,0.3)",
              borderRadius: 8,
              padding: "8px 10px",
              wordBreak: "break-all",
              marginBottom: 18,
            }}
          >
            session: {sessionId}
          </div>
        )}
        <Link
          to="/"
          style={{
            display: "inline-block",
            padding: "10px 20px",
            borderRadius: 10,
            background: "#00e5b0",
            color: "#04110d",
            fontWeight: 700,
            fontSize: 14,
            textDecoration: "none",
          }}
        >
          Return to Ego Blockchain
        </Link>
      </div>
    </div>
  );
}
